import { watch } from "@vue/composition-api";
import { useDrivewealthStore } from "@/shared/store/drivewealth";
import { useInvestmentThresholdStore } from "@/shared/store/investmentThreshold";

const onInvestmentProviderChanged = () => {
    const investmentThresholdStore = useInvestmentThresholdStore();

    if (!investmentThresholdStore.isDrivewealthInvestmentProvider) {
        return;
    }

    const drivewealthStore = useDrivewealthStore();

    drivewealthStore.loadAccountSummariesV2({});
};

export const investmentThresholdStoreWatch = () => {
    const investmentThresholdStore = useInvestmentThresholdStore();
    watch(() => investmentThresholdStore.investmentProvider, onInvestmentProviderChanged);
};